import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'input-file',
  shadow: false,
})
export class InputFile {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() required: boolean;
  @Prop() tooltip: string;
  @Prop() multiple: boolean;
  @Prop() accept: string;
  @Prop() size: number;
  @Prop() dataTab: string;

  render() {
    return (
      <>
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <input class="form-control-stencil form-control bg-outline-primary" type="file" data-tab={this.dataTab} name={this.name} required={this.required} value={this.value} multiple={this.multiple} accept={this.accept} size={this.size} />
      </>
    );
  }
}
